import {Router} from '@angular/router';
import {ErrorHandler, Injectable, Injector, NgZone} from '@angular/core';
import {CookiesManager} from '../../core/cookies';
import {NotificationManager} from '../../../../common/providers/notification';
import {ServerException, UnavailableException} from '../../../../common/providers/exception';

@Injectable()
export class DashboardErrorHandler extends ErrorHandler {

    private router: Router;

    constructor(private injector: Injector, private notificationManager: NotificationManager, private ngZone: NgZone) {
        super();
    }

    handleError(error: any): void {
        //todo andrey use DI
        //noinspection TypeScriptUnresolvedVariable
        if (error instanceof ServerException) {
            switch (error.status) {
                case 400: {
                    //todo andrey build default message
                    this.notificationManager.error(error.message || 'Unknown server validation', true);
                    break;
                }
                case 401: {
                    CookiesManager.clearToken();
                    this.getRouter().navigate(['login']);
                    break;
                }
                case 403: {
                    this.navigateToUnauthorizedComponent();
                    break;
                }
                default: {
                    this.navigateToErrorComponent();
                }
            }
        } else if (error instanceof UnavailableException) {
            this.navigateToErrorComponent();
        } else {
            super.handleError(error);
        }

    }

    private navigateToErrorComponent() {
        if (CookiesManager.isTokenExist()) {
            this.ngZone.run(() => {
                this.getRouter().navigate(['space', 'error']);
            });
        } else {
            this.ngZone.run(() => {
                this.getRouter().navigate(['error']);
            });
        }
    }

    private navigateToUnauthorizedComponent() {
        if (CookiesManager.isTokenExist()) {
            this.ngZone.run(() => {
                this.getRouter().navigate(['space', 'unauthorized']);
            });
        } else {
            this.ngZone.run(() => {
                this.getRouter().navigate(['unauthorized']);
            });
        }
    }

    private getRouter(): Router {
        return this.router == null
            ? this.router = this.injector.get(Router)
            : this.router;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/error/dashboard.error.handler.ts